module.exports = __webpack_public_path__ + "static/media/curriculum-francisvelueta.2aa09148.pdf";